import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  HStack,
  Icon,
  Text,
} from '@wegroup/design-system';
import React from 'react';
import { useLocale } from '../../../../../i18n';
import useSetQueryParam from '../../../../common/src/hooks/query-params/useAddQueryParam';
import useLanguageOptions from '../../../../common/src/hooks/useLanguageOptions';
import useTempLanguage from '../../../../flows/src/hooks/useTempLanguage';

const LanguagePicker: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { setTempLanguage } = useTempLanguage();
  const { userLang } = useLocale();
  const addQueryParam = useSetQueryParam();
  const languages = useLanguageOptions();

  const handleLanguageChange = (lang: string) => {
    setTempLanguage(lang);
    addQueryParam({ lang: lang.toLowerCase() });
  };

  return (
    <Menu>
      <MenuButton
        position="absolute"
        top="6"
        right="6"
        cursor="pointer"
        zIndex="2"
      >
        <HStack>
          <Text>{userLang.toUpperCase()}</Text>
          <Icon name="GeneralActionsChevronDown" color="currentColor" />
        </HStack>
      </MenuButton>
      <MenuList>
        {languages.map(({ label, value, locale }) => (
          <MenuItem
            key={locale || value}
            onClick={() => handleLanguageChange(value)}
          >
            {label}
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

export default LanguagePicker;
